/*global  VeloxWebView*/


var extension = {} ;
extension.name = "phCorrection-field" ;

//must run after fields
extension.mustRunAfter = ["fields", "country"] ;

var COUNTRY_AVAILABILITY = {
    "PH_PLUS"      : { FR: true, DE: true, ES: true, GB: true},  
    "PH_PLUS_LIQ"  : { FR: true, DE: true, ES: true, GB: false},  
    "PH_MINUS"     : { FR: true, DE: true, ES: true, GB: true},  
    "PH_MINUS_LIQ" : { FR: true, DE: true, ES: true, GB: true},  
    "PH_MINUS_LIQ_ANTICALC" : { FR: true, DE: true, ES: true, GB: true},  
};


function computeOptions(){
    return Object.keys(COUNTRY_AVAILABILITY).filter(function(p){
        //filter by country availability
        return COUNTRY_AVAILABILITY[p][VeloxWebView.country.get()] ;
    }).map(function(p){
        return {
            id: p,
            label: VeloxWebView.tr("fields.values.pool.p_ph_correction."+p)
        } ;
    }) ;
}

extension.init = function(){
    var view = this ;
    view.on("initDone", function(){
        var filterEl = view.viewRootEl.querySelector('[data-field-def="pool.p_ph_correction"]');
        if(filterEl){
            view.on("render", function(){
                filterEl.setOptions(computeOptions()) ;
            }) ;
        }   
    }) ;
} ;




module.exports = extension ;